// extracted by mini-css-extract-plugin
export default {"sortIcon":"TableSortIcon_sortIcon__U8s4W","sortIconAsc":"TableSortIcon_sortIconAsc__BQB+e","sortIconDesc":"TableSortIcon_sortIconDesc__ltByp"};